import { Comunications } from 'models/Comunications'

class ComunicationsDto {
    static fromJson(data) {
        const transformedData = data.map(({ id, title, body, files, createdAt, read, readAt }) => ({
            id,
            title,
            body,
            attachments: files,
            createdAt,
            read,
            readAt,
        }))

        return new Comunications(transformedData)
    }
}

export default ComunicationsDto
